const PROMPTS_EN = [
  "Describe what you did yesterday.",
  "Write about your favourite food.",
  "What are you looking forward to this week?",
  "Describe a place you love.",
  "Write about your morning routine.",
  "What did you do last weekend?",
  "Describe your hometown.",
  "Write about a recent trip or journey.",
  "What is your favourite season and why?",
  "Describe a friend or family member.",
  "Write about a hobby you enjoy.",
  "What was the last film or show you watched?",
  "Describe your ideal day.",
  "Write about a challenge you faced recently.",
  "What do you enjoy doing in your free time?",
  "Describe a meal you recently cooked or ate.",
  "Write about your favourite book or story.",
  "What is something you are proud of?",
  "Describe a dream you remember.",
  "Write about your plans for the future.",
  "What makes you happy?",
  "Describe the weather today.",
  "Write about something new you learned recently.",
  "What do you like most about where you live?",
  "Describe a tradition or celebration you enjoy.",
  "Write about a skill you want to improve.",
  "What is something you find difficult?",
  "Describe a memorable moment from your childhood.",
  "Write about a goal you are working towards.",
  "What is something you are grateful for today?",
  "Describe your favourite type of music.",
  "Write about a sport or physical activity you enjoy.",
  "What would you do with a free day?",
  "Describe a market or shop you enjoy visiting.",
  "Write about something funny that happened recently.",
  "What is something that surprised you recently?",
  "Describe your daily commute or how you get around.",
  "Write about a person who has influenced you.",
  "What is your favourite time of day and why?",
  "Describe a technology you use every day.",
  "Write about something you would like to change.",
  "What is your favourite type of weather?",
  "Describe a local landmark or attraction.",
  "Write about something you are currently learning.",
  "What do you enjoy about studying languages?",
  "Describe a conversation you had recently.",
  "Write about a small moment that made you smile.",
  "What is a word in this language you find interesting?",
  "Describe something beautiful you saw recently.",
  "Write about what you hope to do this year.",
];

const PROMPTS_JA = [
  "昨日したことを書いてください。",
  "好きな食べ物について書いてください。",
  "今週楽しみにしていることは何ですか？",
  "好きな場所を描写してください。",
  "朝のルーティンについて書いてください。",
  "先週末は何をしましたか？",
  "故郷について書いてください。",
  "最近の旅行や小旅行について書いてください。",
  "好きな季節とその理由を教えてください。",
  "友人や家族について書いてください。",
  "楽しんでいる趣味について書いてください。",
  "最後に見た映画やドラマは何ですか？",
  "理想の一日を描写してください。",
  "最近直面した困難について書いてください。",
  "自由な時間に何をするのが好きですか？",
  "最近作ったり食べたりした食事を描写してください。",
  "好きな本や物語について書いてください。",
  "誇りに思っていることは何ですか？",
  "覚えている夢について書いてください。",
  "将来の計画について書いてください。",
  "何があなたを幸せにしますか？",
  "今日の天気を描写してください。",
  "最近新しく学んだことについて書いてください。",
  "住んでいる場所の好きなところは何ですか？",
  "楽しんでいる伝統やお祝いについて書いてください。",
  "磨きたいスキルについて書いてください。",
  "難しいと感じることは何ですか？",
  "子供の頃の思い出に残る瞬間を書いてください。",
  "取り組んでいる目標について書いてください。",
  "今日感謝していることは何ですか？",
  "好きな音楽のジャンルを描写してください。",
  "楽しんでいるスポーツや身体的な活動について書いてください。",
  "自由な一日があったら何をしますか？",
  "よく行く市場やお店を描写してください。",
  "最近あった面白いことについて書いてください。",
  "最近驚いたことは何ですか？",
  "毎日の通勤や移動方法を描写してください。",
  "あなたに影響を与えた人について書いてください。",
  "一日の中で好きな時間帯とその理由を教えてください。",
  "毎日使っているテクノロジーを描写してください。",
  "変えたいと思うことについて書いてください。",
  "好きな天気の種類は何ですか？",
  "地元の名所や観光地を描写してください。",
  "現在学んでいることについて書いてください。",
  "言語を勉強することの楽しいところは何ですか？",
  "最近した会話について書いてください。",
  "笑顔になった小さな瞬間について書いてください。",
  "この言語で興味深いと思う単語は何ですか？",
  "最近見た美しいものを描写してください。",
  "今年やりたいことについて書いてください。",
];

const PROMPTS_ES = [
  "Describe lo que hiciste ayer.",
  "Escribe sobre tu comida favorita.",
  "¿Qué esperas con ansias esta semana?",
  "Describe un lugar que amas.",
  "Escribe sobre tu rutina matutina.",
  "¿Qué hiciste el fin de semana pasado?",
  "Describe tu ciudad natal.",
  "Escribe sobre un viaje reciente.",
  "¿Cuál es tu estación favorita y por qué?",
  "Describe a un amigo o familiar.",
  "Escribe sobre un pasatiempo que disfrutas.",
  "¿Cuál fue la última película o serie que viste?",
  "Describe tu día ideal.",
  "Escribe sobre un desafío que enfrentaste recientemente.",
  "¿Qué disfrutas hacer en tu tiempo libre?",
  "Describe una comida que cocinaste o comiste recientemente.",
  "Escribe sobre tu libro o historia favorita.",
  "¿De qué estás orgulloso?",
  "Describe un sueño que recuerdas.",
  "Escribe sobre tus planes para el futuro.",
  "¿Qué te hace feliz?",
  "Describe el clima de hoy.",
  "Escribe sobre algo nuevo que aprendiste recientemente.",
  "¿Qué es lo que más te gusta de donde vives?",
  "Describe una tradición o celebración que disfrutas.",
  "Escribe sobre una habilidad que quieres mejorar.",
  "¿Qué es algo que encuentras difícil?",
  "Describe un momento memorable de tu infancia.",
  "Escribe sobre una meta que estás persiguiendo.",
  "¿Por qué estás agradecido hoy?",
  "Describe tu tipo de música favorita.",
  "Escribe sobre un deporte o actividad física que disfrutas.",
  "¿Qué harías con un día libre?",
  "Describe un mercado o tienda que te gusta visitar.",
  "Escribe sobre algo gracioso que pasó recientemente.",
  "¿Qué te sorprendió recientemente?",
  "Describe tu trayecto diario o cómo te movilizas.",
  "Escribe sobre una persona que te ha influenciado.",
  "¿Cuál es tu hora favorita del día y por qué?",
  "Describe una tecnología que usas todos los días.",
  "Escribe sobre algo que te gustaría cambiar.",
  "¿Cuál es tu tipo de clima favorito?",
  "Describe un monumento o atracción local.",
  "Escribe sobre algo que estás aprendiendo actualmente.",
  "¿Qué disfrutas del estudio de idiomas?",
  "Describe una conversación que tuviste recientemente.",
  "Escribe sobre un pequeño momento que te hizo sonreír.",
  "¿Cuál es una palabra en este idioma que encuentras interesante?",
  "Describe algo hermoso que viste recientemente.",
  "Escribe sobre lo que esperas hacer este año.",
];

const PROMPTS_ZH = [
  "描述你昨天做了什么。",
  "写写你最喜欢的食物。",
  "你这周期待什么？",
  "描述一个你喜欢的地方。",
  "写写你的晨间习惯。",
  "上周末你做了什么？",
  "描述你的家乡。",
  "写写最近的一次旅行。",
  "你最喜欢哪个季节，为什么？",
  "描述一个朋友或家庭成员。",
  "写写你喜欢的一个爱好。",
  "你最近看的电影或电视剧是什么？",
  "描述你理想中的一天。",
  "写写你最近面对的一个挑战。",
  "你在空闲时间喜欢做什么？",
  "描述你最近做的或吃的一顿饭。",
  "写写你最喜欢的书或故事。",
  "你为什么感到自豪？",
  "描述一个你记得的梦。",
  "写写你对未来的计划。",
  "什么让你快乐？",
  "描述今天的天气。",
  "写写你最近学到的新东西。",
  "你最喜欢居住地的什么？",
  "描述你喜欢的一个传统或庆典。",
  "写写你想提高的一项技能。",
  "你觉得什么事情很困难？",
  "描述童年中一个难忘的时刻。",
  "写写你正在努力实现的目标。",
  "今天你感激什么？",
  "描述你最喜欢的音乐类型。",
  "写写你喜欢的运动或体育活动。",
  "如果有一天自由时间，你会做什么？",
  "描述你喜欢去的市场或商店。",
  "写写最近发生的一件有趣的事。",
  "最近有什么事让你感到惊讶？",
  "描述你的日常通勤或出行方式。",
  "写写一个影响了你的人。",
  "你最喜欢一天中的哪个时段，为什么？",
  "描述你每天使用的一项技术。",
  "写写你想改变的事情。",
  "你最喜欢什么样的天气？",
  "描述当地的一个地标或景点。",
  "写写你目前正在学习的东西。",
  "你喜欢学习语言的哪些方面？",
  "描述你最近进行的一次对话。",
  "写写一个让你微笑的小瞬间。",
  "这门语言中有哪个词让你觉得有趣？",
  "描述你最近看到的美丽事物。",
  "写写你今年希望做的事情。",
];

const PROMPTS_FR = [
  "Décrivez ce que vous avez fait hier.",
  "Écrivez sur votre nourriture préférée.",
  "Qu'attendez-vous avec impatience cette semaine ?",
  "Décrivez un endroit que vous aimez.",
  "Écrivez sur votre routine matinale.",
  "Qu'avez-vous fait le week-end dernier ?",
  "Décrivez votre ville natale.",
  "Écrivez sur un voyage récent.",
  "Quelle est votre saison préférée et pourquoi ?",
  "Décrivez un ami ou un membre de votre famille.",
  "Écrivez sur un loisir que vous appréciez.",
  "Quel est le dernier film ou série que vous avez regardé ?",
  "Décrivez votre journée idéale.",
  "Écrivez sur un défi que vous avez récemment relevé.",
  "Qu'aimez-vous faire pendant votre temps libre ?",
  "Décrivez un repas que vous avez récemment cuisiné ou mangé.",
  "Écrivez sur votre livre ou histoire préféré.",
  "De quoi êtes-vous fier ?",
  "Décrivez un rêve dont vous vous souvenez.",
  "Écrivez sur vos projets pour l'avenir.",
  "Qu'est-ce qui vous rend heureux ?",
  "Décrivez la météo aujourd'hui.",
  "Écrivez sur quelque chose de nouveau que vous avez appris récemment.",
  "Qu'aimez-vous le plus dans l'endroit où vous vivez ?",
  "Décrivez une tradition ou une célébration que vous appréciez.",
  "Écrivez sur une compétence que vous souhaitez améliorer.",
  "Qu'est-ce que vous trouvez difficile ?",
  "Décrivez un moment mémorable de votre enfance.",
  "Écrivez sur un objectif que vous poursuivez.",
  "Pour quoi êtes-vous reconnaissant aujourd'hui ?",
  "Décrivez votre type de musique préféré.",
  "Écrivez sur un sport ou une activité physique que vous appréciez.",
  "Que feriez-vous avec une journée libre ?",
  "Décrivez un marché ou un magasin que vous aimez visiter.",
  "Écrivez sur quelque chose de drôle qui s'est passé récemment.",
  "Qu'est-ce qui vous a surpris récemment ?",
  "Décrivez votre trajet quotidien ou votre façon de vous déplacer.",
  "Écrivez sur une personne qui vous a influencé.",
  "Quelle est votre heure préférée de la journée et pourquoi ?",
  "Décrivez une technologie que vous utilisez tous les jours.",
  "Écrivez sur quelque chose que vous aimeriez changer.",
  "Quel est votre type de temps préféré ?",
  "Décrivez un monument ou une attraction locale.",
  "Écrivez sur quelque chose que vous apprenez actuellement.",
  "Qu'appréciez-vous dans l'étude des langues ?",
  "Décrivez une conversation que vous avez eue récemment.",
  "Écrivez sur un petit moment qui vous a fait sourire.",
  "Quel est un mot dans cette langue que vous trouvez intéressant ?",
  "Décrivez quelque chose de beau que vous avez vu récemment.",
  "Écrivez sur ce que vous espérez faire cette année.",
];

const PROMPTS_DE = [
  "Beschreiben Sie, was Sie gestern gemacht haben.",
  "Schreiben Sie über Ihr Lieblingsessen.",
  "Worauf freuen Sie sich diese Woche?",
  "Beschreiben Sie einen Ort, den Sie lieben.",
  "Schreiben Sie über Ihre Morgenroutine.",
  "Was haben Sie letztes Wochenende gemacht?",
  "Beschreiben Sie Ihre Heimatstadt.",
  "Schreiben Sie über eine kürzliche Reise.",
  "Was ist Ihre Lieblingsjahreszeit und warum?",
  "Beschreiben Sie einen Freund oder ein Familienmitglied.",
  "Schreiben Sie über ein Hobby, das Sie genießen.",
  "Was war der letzte Film oder die letzte Serie, die Sie gesehen haben?",
  "Beschreiben Sie Ihren idealen Tag.",
  "Schreiben Sie über eine Herausforderung, der Sie kürzlich begegnet sind.",
  "Was tun Sie gerne in Ihrer Freizeit?",
  "Beschreiben Sie eine Mahlzeit, die Sie kürzlich gekocht oder gegessen haben.",
  "Schreiben Sie über Ihr Lieblingsbuch oder Ihre Lieblingsgeschichte.",
  "Worauf sind Sie stolz?",
  "Beschreiben Sie einen Traum, an den Sie sich erinnern.",
  "Schreiben Sie über Ihre Pläne für die Zukunft.",
  "Was macht Sie glücklich?",
  "Beschreiben Sie das Wetter heute.",
  "Schreiben Sie über etwas Neues, das Sie kürzlich gelernt haben.",
  "Was mögen Sie an dem Ort, an dem Sie leben, am meisten?",
  "Beschreiben Sie eine Tradition oder Feier, die Sie genießen.",
  "Schreiben Sie über eine Fähigkeit, die Sie verbessern möchten.",
  "Was finden Sie schwierig?",
  "Beschreiben Sie einen unvergesslichen Moment aus Ihrer Kindheit.",
  "Schreiben Sie über ein Ziel, das Sie verfolgen.",
  "Wofür sind Sie heute dankbar?",
  "Beschreiben Sie Ihre Lieblingsmusikart.",
  "Schreiben Sie über eine Sportart oder körperliche Aktivität, die Sie genießen.",
  "Was würden Sie mit einem freien Tag machen?",
  "Beschreiben Sie einen Markt oder ein Geschäft, das Sie gerne besuchen.",
  "Schreiben Sie über etwas Lustiges, das kürzlich passiert ist.",
  "Was hat Sie kürzlich überrascht?",
  "Beschreiben Sie Ihren täglichen Weg zur Arbeit oder wie Sie sich fortbewegen.",
  "Schreiben Sie über eine Person, die Sie beeinflusst hat.",
  "Was ist Ihre Lieblingstageszeit und warum?",
  "Beschreiben Sie eine Technologie, die Sie jeden Tag verwenden.",
  "Schreiben Sie über etwas, das Sie ändern möchten.",
  "Was ist Ihr Lieblingswetter?",
  "Beschreiben Sie ein lokales Wahrzeichen oder eine Attraktion.",
  "Schreiben Sie über etwas, das Sie gerade lernen.",
  "Was gefällt Ihnen am Sprachenlernen?",
  "Beschreiben Sie ein Gespräch, das Sie kürzlich geführt haben.",
  "Schreiben Sie über einen kleinen Moment, der Sie zum Lächeln gebracht hat.",
  "Was ist ein Wort in dieser Sprache, das Sie interessant finden?",
  "Beschreiben Sie etwas Schönes, das Sie kürzlich gesehen haben.",
  "Schreiben Sie über das, was Sie dieses Jahr zu tun hoffen.",
];

const PROMPTS_KO = [
  "어제 한 일을 묘사해 보세요.",
  "가장 좋아하는 음식에 대해 써보세요.",
  "이번 주에 기대하는 것은 무엇인가요?",
  "좋아하는 장소를 묘사해 보세요.",
  "아침 루틴에 대해 써보세요.",
  "지난 주말에 무엇을 했나요?",
  "고향을 묘사해 보세요.",
  "최근의 여행에 대해 써보세요.",
  "가장 좋아하는 계절과 그 이유는 무엇인가요?",
  "친구나 가족 구성원을 묘사해 보세요.",
  "즐기는 취미에 대해 써보세요.",
  "마지막으로 본 영화나 드라마는 무엇인가요?",
  "이상적인 하루를 묘사해 보세요.",
  "최근에 직면한 도전에 대해 써보세요.",
  "자유 시간에 무엇을 하는 걸 즐기나요?",
  "최근에 요리하거나 먹은 음식을 묘사해 보세요.",
  "가장 좋아하는 책이나 이야기에 대해 써보세요.",
  "자랑스러운 것은 무엇인가요?",
  "기억하는 꿈을 묘사해 보세요.",
  "미래에 대한 계획을 써보세요.",
  "무엇이 당신을 행복하게 만드나요?",
  "오늘의 날씨를 묘사해 보세요.",
  "최근에 새로 배운 것에 대해 써보세요.",
  "사는 곳에서 가장 좋아하는 것은 무엇인가요?",
  "즐기는 전통이나 기념행사를 묘사해 보세요.",
  "향상시키고 싶은 기술에 대해 써보세요.",
  "어렵다고 느끼는 것은 무엇인가요?",
  "어린 시절의 기억에 남는 순간을 써보세요.",
  "이루고자 하는 목표에 대해 써보세요.",
  "오늘 감사한 것은 무엇인가요?",
  "가장 좋아하는 음악 장르를 묘사해 보세요.",
  "즐기는 스포츠나 신체 활동에 대해 써보세요.",
  "자유로운 하루가 있다면 무엇을 할 건가요?",
  "즐겨 방문하는 시장이나 가게를 묘사해 보세요.",
  "최근에 있었던 재미있는 일에 대해 써보세요.",
  "최근에 놀란 것은 무엇인가요?",
  "매일의 통근이나 이동 방법을 묘사해 보세요.",
  "당신에게 영향을 준 사람에 대해 써보세요.",
  "하루 중 좋아하는 시간대와 그 이유는 무엇인가요?",
  "매일 사용하는 기술을 묘사해 보세요.",
  "바꾸고 싶은 것에 대해 써보세요.",
  "가장 좋아하는 날씨 유형은 무엇인가요?",
  "지역 명소나 관광지를 묘사해 보세요.",
  "현재 배우고 있는 것에 대해 써보세요.",
  "언어 공부에서 즐기는 점은 무엇인가요?",
  "최근에 나눈 대화를 묘사해 보세요.",
  "미소 짓게 했던 작은 순간에 대해 써보세요.",
  "이 언어에서 흥미롭다고 생각하는 단어는 무엇인가요?",
  "최근에 본 아름다운 것을 묘사해 보세요.",
  "올해 하고 싶은 것에 대해 써보세요.",
];

const PROMPTS_PT = [
  "Descreva o que você fez ontem.",
  "Escreva sobre sua comida favorita.",
  "O que você está esperando para esta semana?",
  "Descreva um lugar que você ama.",
  "Escreva sobre sua rotina matinal.",
  "O que você fez no fim de semana passado?",
  "Descreva sua cidade natal.",
  "Escreva sobre uma viagem recente.",
  "Qual é a sua estação favorita e por quê?",
  "Descreva um amigo ou familiar.",
  "Escreva sobre um hobby que você gosta.",
  "Qual foi o último filme ou série que você assistiu?",
  "Descreva seu dia ideal.",
  "Escreva sobre um desafio que você enfrentou recentemente.",
  "O que você gosta de fazer no seu tempo livre?",
  "Descreva uma refeição que você cozinhou ou comeu recentemente.",
  "Escreva sobre seu livro ou história favorita.",
  "Do que você se orgulha?",
  "Descreva um sonho que você se lembra.",
  "Escreva sobre seus planos para o futuro.",
  "O que te faz feliz?",
  "Descreva o tempo hoje.",
  "Escreva sobre algo novo que você aprendeu recentemente.",
  "O que você mais gosta no lugar onde mora?",
  "Descreva uma tradição ou celebração que você aprecia.",
  "Escreva sobre uma habilidade que você quer melhorar.",
  "O que você acha difícil?",
  "Descreva um momento memorável da sua infância.",
  "Escreva sobre um objetivo que você está perseguindo.",
  "Pelo que você é grato hoje?",
  "Descreva seu tipo de música favorito.",
  "Escreva sobre um esporte ou atividade física que você gosta.",
  "O que você faria com um dia livre?",
  "Descreva um mercado ou loja que você gosta de visitar.",
  "Escreva sobre algo engraçado que aconteceu recentemente.",
  "O que te surpreendeu recentemente?",
  "Descreva seu trajeto diário ou como você se locomove.",
  "Escreva sobre uma pessoa que te influenciou.",
  "Qual é sua hora favorita do dia e por quê?",
  "Descreva uma tecnologia que você usa todos os dias.",
  "Escreva sobre algo que você gostaria de mudar.",
  "Qual é o seu tipo de clima favorito?",
  "Descreva um ponto turístico ou atração local.",
  "Escreva sobre algo que você está aprendendo atualmente.",
  "O que você gosta em estudar idiomas?",
  "Descreva uma conversa que você teve recentemente.",
  "Escreva sobre um pequeno momento que te fez sorrir.",
  "Qual é uma palavra neste idioma que você acha interessante?",
  "Descreva algo bonito que você viu recentemente.",
  "Escreva sobre o que você espera fazer este ano.",
];

const PROMPTS_IT = [
  "Descrivi cosa hai fatto ieri.",
  "Scrivi del tuo cibo preferito.",
  "Cosa aspetti con ansia questa settimana?",
  "Descrivi un posto che ami.",
  "Scrivi della tua routine mattutina.",
  "Cosa hai fatto lo scorso fine settimana?",
  "Descrivi la tua città natale.",
  "Scrivi di un recente viaggio.",
  "Qual è la tua stagione preferita e perché?",
  "Descrivi un amico o un familiare.",
  "Scrivi di un hobby che ti piace.",
  "Qual è l'ultimo film o serie che hai guardato?",
  "Descrivi la tua giornata ideale.",
  "Scrivi di una sfida che hai affrontato di recente.",
  "Cosa ti piace fare nel tempo libero?",
  "Descrivi un pasto che hai cucinato o mangiato di recente.",
  "Scrivi del tuo libro o storia preferita.",
  "Di cosa sei orgoglioso?",
  "Descrivi un sogno che ricordi.",
  "Scrivi dei tuoi piani per il futuro.",
  "Cosa ti rende felice?",
  "Descrivi il tempo oggi.",
  "Scrivi di qualcosa di nuovo che hai imparato di recente.",
  "Cosa ti piace di più del posto in cui vivi?",
  "Descrivi una tradizione o celebrazione che apprezzi.",
  "Scrivi di un'abilità che vuoi migliorare.",
  "Cosa trovi difficile?",
  "Descrivi un momento memorabile della tua infanzia.",
  "Scrivi di un obiettivo che stai perseguendo.",
  "Per cosa sei grato oggi?",
  "Descrivi il tuo tipo di musica preferito.",
  "Scrivi di uno sport o attività fisica che ti piace.",
  "Cosa faresti con una giornata libera?",
  "Descrivi un mercato o negozio che ti piace visitare.",
  "Scrivi di qualcosa di divertente che è successo di recente.",
  "Cosa ti ha sorpreso di recente?",
  "Descrivi il tuo tragitto quotidiano o come ti sposti.",
  "Scrivi di una persona che ti ha influenzato.",
  "Qual è la tua ora preferita della giornata e perché?",
  "Descrivi una tecnologia che usi ogni giorno.",
  "Scrivi di qualcosa che vorresti cambiare.",
  "Qual è il tuo tipo di tempo preferito?",
  "Descrivi un monumento o un'attrazione locale.",
  "Scrivi di qualcosa che stai imparando attualmente.",
  "Cosa ti piace dello studio delle lingue?",
  "Descrivi una conversazione che hai avuto di recente.",
  "Scrivi di un piccolo momento che ti ha fatto sorridere.",
  "Qual è una parola in questa lingua che trovi interessante?",
  "Descrivi qualcosa di bello che hai visto di recente.",
  "Scrivi di cosa speri di fare quest'anno.",
];

const PROMPTS_RU = [
  "Опишите, что вы делали вчера.",
  "Напишите о вашей любимой еде.",
  "Чего вы ждёте с нетерпением на этой неделе?",
  "Опишите место, которое вы любите.",
  "Напишите о вашем утреннем распорядке.",
  "Что вы делали в прошлые выходные?",
  "Опишите ваш родной город.",
  "Напишите о недавней поездке.",
  "Какое ваше любимое время года и почему?",
  "Опишите друга или члена семьи.",
  "Напишите о хобби, которым вы занимаетесь.",
  "Какой последний фильм или сериал вы смотрели?",
  "Опишите ваш идеальный день.",
  "Напишите о трудности, с которой вы недавно столкнулись.",
  "Что вам нравится делать в свободное время?",
  "Опишите блюдо, которое вы недавно приготовили или съели.",
  "Напишите о вашей любимой книге или истории.",
  "Чем вы гордитесь?",
  "Опишите сон, который вы помните.",
  "Напишите о ваших планах на будущее.",
  "Что делает вас счастливым?",
  "Опишите сегодняшнюю погоду.",
  "Напишите о чём-то новом, что вы недавно узнали.",
  "Что вам больше всего нравится в месте, где вы живёте?",
  "Опишите традицию или праздник, который вам нравится.",
  "Напишите о навыке, который вы хотите улучшить.",
  "Что вы находите трудным?",
  "Опишите запоминающийся момент из вашего детства.",
  "Напишите о цели, к которой вы стремитесь.",
  "За что вы сегодня благодарны?",
  "Опишите ваш любимый вид музыки.",
  "Напишите о спорте или физической активности, которые вам нравятся.",
  "Что бы вы сделали со свободным днём?",
  "Опишите рынок или магазин, который вам нравится посещать.",
  "Напишите о чём-то смешном, что произошло недавно.",
  "Что вас недавно удивило?",
  "Опишите ваш ежедневный маршрут или способ передвижения.",
  "Напишите о человеке, который повлиял на вас.",
  "Какое ваше любимое время суток и почему?",
  "Опишите технологию, которую вы используете каждый день.",
  "Напишите о чём-то, что вы хотели бы изменить.",
  "Какой ваш любимый тип погоды?",
  "Опишите местную достопримечательность.",
  "Напишите о чём-то, что вы сейчас изучаете.",
  "Что вам нравится в изучении языков?",
  "Опишите разговор, который у вас недавно был.",
  "Напишите о небольшом моменте, который заставил вас улыбнуться.",
  "Какое слово в этом языке вы находите интересным?",
  "Опишите что-то красивое, что вы недавно видели.",
  "Напишите о том, что вы надеетесь сделать в этом году.",
];

const PROMPT_MAP: Record<string, string[]> = {
  Japanese: PROMPTS_JA,
  Spanish: PROMPTS_ES,
  "Chinese (Mandarin)": PROMPTS_ZH,
  French: PROMPTS_FR,
  German: PROMPTS_DE,
  Korean: PROMPTS_KO,
  Portuguese: PROMPTS_PT,
  Italian: PROMPTS_IT,
  Russian: PROMPTS_RU,
};

export function getRandomPromptPair(
  learningLanguage?: string,
  nativeLanguage?: string,
): { learning: string; native: string } {
  const idx = Math.floor(Math.random() * PROMPTS_EN.length);
  const learningList = (learningLanguage && PROMPT_MAP[learningLanguage]) || PROMPTS_EN;
  const nativeList = (nativeLanguage && PROMPT_MAP[nativeLanguage]) || PROMPTS_EN;
  return { learning: learningList[idx], native: nativeList[idx] };
}
